import React from 'react';
import { Flex, TextV2, ButtonV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

interface EmptyStateProps {
  handleBackToWebsite: () => void;
  title: string;
  description: string;
  ctaText: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ handleBackToWebsite, title, description, ctaText }) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      marginBottom={pxToRem(72)}
      maxWidth={250}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={4}
      >
        <TextV2 typographyVariant="display3">
          <span
            role="img"
            aria-label="nicely-done"
          >
            🙌
          </span>
        </TextV2>
        <TextV2 typographyVariant="hed3">{title}</TextV2>
        <TextV2
          typographyVariant="body1"
          textAlign="center"
        >
          {description}
        </TextV2>
      </Flex>
      <ButtonV2
        shape="rounded"
        intent="neutral"
        variant="solid"
        width="100%"
        size="lg"
        marginTop={6}
        onClick={handleBackToWebsite}
      >
        {ctaText}
      </ButtonV2>
    </Flex>
  );
};
